import * as React from 'react';
import { Nav, Tab } from 'react-bootstrap';
import "./index.css";
import PTOAdministration from './PTOAdministration';

interface IProps {

}


const PTO: React.FC<IProps> = (props: IProps) => {

    return (
        <Tab.Container id="pto-tabs" defaultActiveKey="admin">
            <div className="main-content col-sm">
                <Nav variant="tabs" className="">
                    {/* <Nav.Item>
                        <Nav.Link eventKey="request">Request PTO</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="manage">PTO Management</Nav.Link>
                    </Nav.Item> */}
                    <Nav.Item>
                        <Nav.Link eventKey="admin">PTO Administration</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    {/* <Tab.Pane eventKey="request">
                        <PTORequest />
                    </Tab.Pane>
                    <Tab.Pane eventKey="manage">
                        <ManagePTO />
                    </Tab.Pane> */}
                    <Tab.Pane eventKey="admin">
                        <PTOAdministration/>
                    </Tab.Pane>
                </Tab.Content>
            </div>
        </Tab.Container>
    );
}

export default PTO;